<template>
  <div class="assist_action">
    <div class="assist_label">{{ $t('action_set_combination_key') }}</div>
    <div class="assist_display" :class="{ focus: true }">
      <template v-for="(item, index) in keys" :key="index">
        <div class="assist_key_tag" v-if="item > 0">
          {{ getVKText(item) }}
        </div>
        <div v-if="item > 0 && index < keys.length - 1 && keys[index + 1] > 0" class="assist_plus">+</div>
      </template>
      <div v-if="keys.every((k) => k === 0)" class="assist_placeholder">
        {{ $t('please_select_combination_keys') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { VK } from '@/define/define'
import { kbVKTexture } from '@/define/vkcode'
import { getStringAfterDash } from '@/tool/utility'
const props = defineProps<{ keys: VK[]; isConfig?: boolean }>()
const getVKText = (key: number) => {
  if (key == 0x00) {
    return ''
  }
  return props.isConfig ? getStringAfterDash(kbVKTexture[key]) : kbVKTexture[key]
}
</script>

<style scoped lang="less">
.assist_action {
  background: var(--color-white);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: var(--radius-m); /* 12px -> 26px but better keep it consistent with small cards */
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  width: 100%;
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);

  .assist_label {
    font-size: 11px;
    color: var(--color-text-hint);
    font-weight: 600;
    margin-bottom: 2px;
  }

  .assist_display {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 40px;
    width: 100%;
    background: #f7f8fa;
    border: 1px dashed var(--brand-color-pure);
    border-radius: 8px;
    transition: var(--transition-base);

    .assist_key_tag {
      padding: 4px 12px;
      background: var(--brand-color);
      color: #fff;
      border-radius: 4px;
      font-weight: 600;
      font-size: 12.5px;
      box-shadow: 0 4px 8px rgba(255, 107, 0, 0.15);
    }

    .assist_plus {
      font-size: 16px;
      color: var(--brand-color-pure);
      font-weight: 700;
    }

    .assist_placeholder {
      color: var(--color-text-hint);
      opacity: 0.6;
      font-size: 12px;
    }
  }
}
</style>
